import React from 'react'
import { Link } from 'react-router-dom'

export default function TermsPage() {
  return (
    <div className="py-10 sm:py-16 space-y-12">
      <section className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center max-w-2xl mx-auto mb-10">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-[#241F1C]">
            Salgs- og leveringsbetingelser
          </h1>
          <p className="mt-2 text-xs sm:text-sm text-[#6E635C]">
            Vilkår og betingelser gældende for handler med Overgaard Pattegrise.
          </p>
        </div>

        <div className="space-y-8 text-[#241F1C] text-sm sm:text-base leading-relaxed">
          <div className="border-b border-[#E6DFD5] pb-6">
            <h2 className="text-xl font-bold text-[#241F1C] mb-2">Generelle vilkår</h2>
            <p className="text-[#6E635C]">
              Her kan du læse om de vilkår og betingelser, som er gældende, når du handler med Overgaard Pattegrise.
              Du er selvfølgelig mere end velkommen til at kontakte os på toemrerovergaardbyg@gmail.com eller tlf. 25 75 27 24,
              hvis du har uddybende spørgsmål til din bestilling.
            </p>
          </div>

          <div className="space-y-4">
            <h3 className="text-lg font-bold text-[#241F1C]">Bestilling og antal kuverter</h3>
            <p className="text-[#6E635C]">
              Vi anbefaler, at maden bestilles i så god tid som muligt for at sikre, at vi er ledige på den ønskede dato.
              Hvis der er mindre end 14 dage til den ønskede leveringsdato, bedes du kontakte os direkte på tlf. 25 75 27 24 for at afgive din ordre.
            </p>
            <p className="text-[#6E635C]">
              <strong>Ændring i antal kuverter:</strong> Endelig ændring i antallet af kuverter samt valg af menu skal meddeles senest 14 dage før leveringsdatoen.
            </p>
          </div>

          <div className="space-y-4">
            <h3 className="text-lg font-bold text-[#241F1C]">Ordrebekræftelse</h3>
            <p className="text-[#6E635C]">
              Kort efter din bestilling modtager du en ordrebekræftelse pr. mail. Du modtager naturligvis også en skriftlig bekræftelse, hvis du har bestilt over telefonen. Det er vigtigt, at du husker at tjekke, om leveringssted og dato er angivet korrekt.
            </p>
          </div>

          <div className="space-y-4">
            <h3 className="text-lg font-bold text-[#241F1C]">Betaling</h3>
            <p className="text-[#6E635C]">
              Betaling af maden sker efter aftale forud for leveringsdatoen via fremsendt faktura. På ordrebekræftelsen og fakturaen fremgår den nøjagtige dato og kontonummer for indbetalingen. Husk altid at oplyse dit fakturanummer ved overførsel.
            </p>
            <p className="text-[#6E635C]">
              Priser er angivet i henhold til gældende prisliste og tilbud.
            </p>
          </div>

          <div className="space-y-4">
            <h3 className="text-lg font-bold text-[#241F1C]">Levering og ankomst</h3>
            <p className="text-[#6E635C]">
              Vi leverer til hele Sønder Omme og omegn samt omkringliggende byer som Grindsted og Billund. Ved længere afstande kan der aftales et leveringstillæg.
            </p>
            <p className="text-[#6E635C]">
              <strong>Leveringstidspunkt:</strong> Ved bestilling vælges det aftalte tidspunkt for madens servering. Ved helstegt pattegris ankommer grillmesteren 5-7 timer før for at tænde op og tilberede grisen. Sørg for at være til stede og tage imod os på det aftalte tidspunkt.
            </p>
            <p className="text-[#6E635C]">
              <strong>Forhold på stedet:</strong> I tilfælde af regnvejr skal grillen kunne stå i tørvejr (f.eks. carport, garage eller pavillon). Der skal være kørefast adgang til grilltraileren, og der skal stilles et bord til rådighed til udskæring.
            </p>
          </div>

          <div className="space-y-4">
            <h3 className="text-lg font-bold text-[#241F1C]">Reklamation</h3>
            <p className="text-[#6E635C]">
              Hvis noget mod forventning ikke har levet op til forventningerne, hører vi meget gerne fra dig hurtigst muligt. Kontakt os straks på tlf. 25 75 27 24, så vi kan reagere og yde den bedst mulige service med det samme.
            </p>
          </div>

          <div className="border-t border-[#E6DFD5] pt-6 space-y-2 text-xs text-[#6E635C]">
            <h4 className="font-bold text-sm text-[#241F1C]">Forretningsoplysninger</h4>
            <p className="font-medium text-[#241F1C]">Overgaard Pattegrise</p>
            <p>Adresse: Simmelbrovej 52, 7260 Sønder Omme</p>
            <p>CVR: 45834719</p>
            <p>Telefon: 25 75 27 24</p>
            <p>E-mail: toemrerovergaardbyg@gmail.com</p>
          </div>
        </div>

        <div className="mt-8 text-center">
          <Link
            to="/kontakt"
            className="inline-flex items-center gap-2 bg-[#C25E27] hover:bg-[#A84E1C] text-white px-7 py-3 font-bold text-sm transition-shadow duration-300 hover:shadow-lg"
          >
            <span>Har du spørgsmål? Kontakt os her</span>
          </Link>
        </div>
      </section>
    </div>
  )
}
